import React from 'react';
import { Dialog, DialogTitle, Typography, DialogActions, DialogContent, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

const ConfirmRatificationBlacklist = ({ open, setOpen, handleRatificationBlacklist }) => (
  <Dialog open={open}>
    <DialogTitle>
      <Typography variant="h5">
        Confirmación
      </Typography>
    </DialogTitle>
    <DialogContent dividers>
      ¿Está segura/o que desea llevar a cabo esta acción?
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={handleRatificationBlacklist}
      >
        Confirmar
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={() => setOpen(false)}
      >
        Cancelar
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmRatificationBlacklist.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleRatificationBlacklist: PropTypes.number.isRequired,
};

export default ConfirmRatificationBlacklist;
